import { requiredBoolean, requiredString } from '@/common/utils/zod';
import { z } from 'zod';

export const otpFormSchema = z.object({
  otpCode: requiredString,
  trustUserAgent: requiredBoolean,
});
export type TOTPFormData = z.infer<typeof otpFormSchema>;
